/**
 * @description: 腾讯广告ada一些通用的计算属性
 */
export const projectComputedMethods = {
  /**
   * @description: 判断是批量新建、复制、修改；单条修改流程
   * @return {Object}
   *  - isEdit: 是否编辑状态；新建流程从下一步返回到项目编辑时，会在url中添加t=edit
   *  - isDuplicate: 是否复制状态；任务批量复制
   *  - isModify: 是否修改状态；任务批量修改
   *  - isCreate: 是否新建状态；任务批量新建
   *  - isADA: 是否ADA
   *  - isV3: 是否V3
   */
  pageStates() {
    const { query, path } = this.$route
    const isEdit = query.t === 'edit'
    // 批量复制
    const isDuplicate = path.includes('/duplicate/')
    // 批量修改
    const isModify = path.includes('/edit/')
    // 单条修改
    const isUpdate = path.includes('/plan-edit')
    // 单条修改创意
    const isUpdateCreative = path.includes('/creative-edit')
    // 批量新建
    const isCreate = path.includes('/create/')
    // 腾讯广告3.0模板新建计划
    const isTemplate = path.includes('/gdt/template')
    // 腾讯广告3.0老版
    const isV3 = path.includes('/tencentv3') || isTemplate
    const isADA = path.includes('/tencentada/')
    return {
      isEdit,
      isDuplicate,
      isModify,
      isUpdate,
      isUpdateCreative,
      isCreate,
      isTemplate,
      isV3,
      isADA
    }
  },
  /**
     * @description: 根据已选账号id映射对应账号json
     * @return [
     *    { name: '751725293（技术使用勿动）', id: 5165 },
          { name: '21589747', id: 8791 }
       ]
     */
  adAccounts() {
    const adAccounts = this.accountList.filter((acc) => this.planForm.accounts.includes(acc.id))
    return adAccounts
  }
}

/**
 * @description: 腾讯广告ada一些通用的实例方法
 */
export const projectMethods = {
  /**
   * @description: 清空外部游戏id
   */
  onClearPormotedObject() {
    this.planForm = {
      ...this.planForm,
      promotedObject: {}
    }
  }
}
